export default "__VITE_ASSET__B$9ysi6Z__"